import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	undo: {
		id: 'ark.action.undo.button.text',
		defaultMessage: 'Undo',
		description: 'The text of a button in a flag to allow users to undo a dismissal action',
	},
	reasonsIntro: {
		id: 'ark.action.reasonsIntro.common.text',
		defaultMessage:
			'We think {product} will improve your team’s productivity. The recommendation is based on:',
		description:
			'An introduction for the reasons for a product recommendation. The {product} is a placeholder for the product name.',
	},
	learnMoreAboutDataPolicy: {
		id: 'ark.action.learnMoreAboutDataPolicy.common.text',
		defaultMessage: 'Learn more about your data privacy with Atlassian',
		description: 'A link to a page that explains Atlassian’s data privacy policy',
	},
});
